import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
export interface TokenState {
    price: string;
    amount: string;
    buyMode: boolean;
}

const initialState: TokenState = {
    price:  '0.00',
    amount: '',
    buyMode: true,
};

export const tokenSlice = createSlice({
    name: 'token',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {        
        setPrice: (state: TokenState, action: PayloadAction<string>) => {
            state.price = action.payload;
        },
        setAmount: (state: TokenState, action: PayloadAction<string>) => {
            state.amount = action.payload;
        },
        setBuyMode: (state: TokenState, action: PayloadAction<boolean>) => {
            state.buyMode = action.payload;
        },
    },
});

export const { setPrice, setAmount, setBuyMode } = tokenSlice.actions;

export const selectBuyMode = (state: RootState) => state.trade.buyMode;
export const selectPrice = (state: RootState) => state.trade.price;
export const selectAmount = (state: RootState) => state.trade.amount;

export default tokenSlice.reducer;
